module.exports = __webpack_public_path__ + "static/media/due-port05.d2cb535f.jpg";